<template>
  <div class="module-container">
    <div class="container">
      <div class="module-header">
        <div class="module-title">开放共赢：我们在寻找优秀的你</div>
        <div class="module-subtitle">加入易隆生态，与 500+ 先行企业共同成长</div>
      </div>

      <div class="supplier-cards">
        <!-- 材料供应商卡片 -->
        <div class="supplier-card">
          <div class="card-image material-image">
            <div class="card-title">材料供应商</div>
          </div>
          <div class="card-content">
            <div class="card-description">
              <div>以前，你追逐项目跑，追着回款催，追着客户推产品。现在，合伙人带着项目找你，平台替你保障回款，整个生态帮你卖货。</div>
              <div>这就是平台的力量，这就是生态的红利。</div>
            </div>
            <ul class="card-benefits">
              <li class="benefit-item">
                <span class="benefit-number material">01</span>
                <span class="benefit-text">海量项目精准推，销售不再大海捞针</span>
              </li>
              <li class="benefit-item">
                <span class="benefit-number material">02</span>
                <span class="benefit-text">数据驱动收入，销售费用直降</span>
              </li>
              <li class="benefit-item">
                <span class="benefit-number material">03</span>
                <span class="benefit-text">平台信用背书，回款板上钉钉</span>
              </li>
              <li class="benefit-item">
                <span class="benefit-number material">04</span>
                <span class="benefit-text">生态联合推广，好产品自己会说话</span>
              </li>
            </ul>
            <div class="card-button material-button" @click="handleRegister('material', supplierStatus)">申请成为材料伙伴/登录</div>
          </div>
        </div>

        <!-- 解决方案供应商卡片 -->
        <div class="supplier-card">
          <div class="card-image solution-image">
            <div class="card-title">解决方案供应商</div>
          </div>
          <div class="card-content">
            <div class="card-description">
              <div>拥有一流的技术却苦于找不到应用场景？加入我们，让您的解决方案通过平台合伙人在数千个真实项目中落地开花。</div>
              <div>&nbsp;</div>
            </div>
            <ul class="card-benefits">
              <li class="benefit-item">
                <span class="benefit-number solution">01</span>
                <span class="benefit-text">覆盖全国各行业的有用户资源的合伙人</span>
              </li>
              <li class="benefit-item">
                <span class="benefit-number solution">02</span>
                <span class="benefit-text">专业的一线交付服务体系支撑</span>
              </li>
              <li class="benefit-item">
                <span class="benefit-number solution">03</span>
                <span class="benefit-text">品牌联合推广与生态溢价</span>
              </li>
            </ul>
            <div class="card-button solution-button" @click="handleRegister('scheme', schemeStatus)">申请成为解决方案伙伴/登录</div>
          </div>
        </div>
      </div>
    </div>
    <need-login-dialog ref="need-login-dialog" inHome></need-login-dialog>
  </div>
</template>

<script>
import NeedLoginDialog from '@/components/NeedLoginDialog';
import { mapActions, mapGetters } from 'vuex';
import { getCurrentUser } from "@/api/home/home.js";

export default {
  components: { NeedLoginDialog },
  data() {
    return {
      /* navigaion: {
        material: {
          Completed: '/supplier/material/index',
          unCertification: '/supplier-signature/basic-info',
          Pending: '/supplier-signature/submitted',
        },
        scheme: {
          Completed: '/supplier/scheme/index',
          unCertification: '/scheme-signature/basic-info',
          Pending: '/scheme-signature/submitted',
        },
      } */
      navigaion: {
        material: '/supplyEcosystem/dashboard',
        scheme: '/schemeEcosystem/dashboard',
      }
    }
  },
  computed: {
    ...mapGetters(['isLoggIn', 'currentUser']),
    schemeStatus() {
      return this.currentUser?.schemeCertificationStatus;
    },
    supplierStatus() {
      return this.currentUser?.supplierCertificationStatus;
    },
  },
  mounted() {
    if (this.isLoggIn) {
      getCurrentUser().then((user) => {
        this.$store.dispatch("setCurrentUser", user?.model || null);
      });
    }
  },
  methods: {
    ...mapActions(['setLoginPopup', 'setLoginCallback']),
    handleEnterSystem(type) {
      this.$router.push(this.navigaion[type]['Completed']);
    },
    /* handleRegister(type, status) {
      if (this.isLoggIn) this.$router.push(this.navigaion[type][status]);
      else {
        this.setLoginPopup(true);
        this.setLoginCallback(user => {
          const status = type === 'material' ? user.supplierCertificationStatus : user.schemeCertificationStatus;
          this.$router.push(this.navigaion[type][status]);
        });
      }
    }, */
    handleRegister(type) {
      if (this.isLoggIn) window.open(`#${this.navigaion[type]}`, '_blank');
      else {
        this.setLoginPopup(true);
        this.setLoginCallback(() => {
          window.open(`#${this.navigaion[type]}`, '_blank');
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.module-container {
  padding: 64px 0;
  background-color: #f9f9f9;

  .container {
    max-width: @content-width;
    margin: 0 auto;
    padding: 0 60px;
  }

  .module-header {
    text-align: center;
    margin-bottom: 48px;

    .module-title {
      font-size: 32px;
      font-weight: 600;
      color: #333;
      margin-bottom: 16px;
    }

    .module-subtitle {
      font-size: 16px;
      color: #999;
    }
  }

  .supplier-cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
  }

  .supplier-card {
      background-color: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 32px rgba(0, 0, 0, 0.1);
      overflow: hidden;
      display: flex;
      flex-direction: column;
      height: 100%;

      .card-image {
        height: 240px;
        background-size: cover;
        background-position: center;
        position: relative;
        display: flex;
        align-items: flex-end;
        padding: 24px 32px;
        background-position: center;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        transition: background-size 0.3s ease;
        &:hover {
          background-size: 110% 110%;
        }

        &.material-image {
          background-image: url('@/assets/img/home/OpennessWinWin/image_material.png');
        }

        &.solution-image {
          background-image: url('@/assets/img/home/OpennessWinWin/image_solution.png');
        }

        .card-title {
          font-size: 24px;
          font-weight: 600;
          color: #fff;
          margin: 0;
        }
      }

      .card-content {
        padding: 24px 32px;
        display: flex;
        flex-direction: column;
        flex: 1;
      }

    .card-description {
      font-size: 16px;
      line-height: 1.8;
      color: #1D2129;
      margin-bottom: 24px;
      text-indent: 2em;
    }

    .card-benefits {
      list-style: none;
      padding: 0;
      margin: 0 0 24px 0;
      flex: 1;

      .benefit-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0;
        }

        .benefit-number {
          display: inline-block;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          font-size: 12px;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 12px;
          flex-shrink: 0;
          &.material {
            background-color: #FFEDD5;
            color: #EA570C;
          }
          &.solution {
            background-color: #d3e0fb;
            color: #225CD8;
          }
        }

        .benefit-text {
          flex: 1;
          font-family: @font-medium;
          font-size: 16px;
          color: #1D2129;
          line-height: 24px;
        }
      }
    }

    .card-button {
      display: block;
      width: 100%;
      margin-top: auto;
      // padding: 12px;
      line-height: 52px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s ease;
      margin-top: auto;

      &.material-button {
        background-color: #FF8201;
        color: #fff;

        &:hover {
          background-color: #e67600;
        }
      }

      &.solution-button {
        background-color: #016FFF;
        color: #fff;

        &:hover {
          background-color: #005ce6;
        }
      }
    }
  }
}
</style>
